import React from 'react';

import backgroundSources from 'Components/Banner/TakeOver/helpers/backgroundSources';
import SkeletonImg, { FROM_MD, BELOW_MD } from 'Components/Skeleton/SkeletonImg';
import SkeletonStripBanner from 'Components/Skeleton/SkeletonStripBanner';

/**
 * The take over banner at the top of the home and listing pages (Components/Banner/TakeOver), for page skeletons.
 * Each breakpoint's banner only shows when the worker has its image (`data-skeleton-if`), as in the app: from md up
 * the background, with the foreground over it if there is one, and below md the mobile banner. Each has the strip
 * banner under it if there is one. From md up, the app also shows a foreground without a background, at its natural
 * height, which a skeleton can't know.
 * Slots: `takeover` (foreground), `takeover-background`, `takeover-mobile` (image URLs), plus SkeletonStripBanner's
 * for `takeover-strip`.
 */
export default function SkeletonTakeOver() {
  return (
    <div className="SkeletonTakeOver">
      <div className="SkeletonTakeOver__desktop" data-skeleton-if="takeover-background">
        <div className="container SkeletonTakeOver__foreground">
          <SkeletonImg slot="takeover" sizes="100vw" maxFallbackWidth={400} media={FROM_MD} />
        </div>
        <SkeletonImg
          slot="takeover-background"
          sizes="100vw"
          sources={backgroundSources}
          media={FROM_MD}
          className="SkeletonTakeOver__background"
        />
      </div>
      <div className="SkeletonTakeOver__mobile" data-skeleton-if="takeover-mobile">
        <SkeletonImg slot="takeover-mobile" sizes="100vw" media={BELOW_MD} />
      </div>
      <SkeletonStripBanner slot="takeover-strip" />
    </div>
  );
}
